import JSZip from 'jszip';
import { fetchDocumentBlob } from '../../../utils/documentDownload';
import type { ScanArchiveDocumentEntry } from './sendScansArchive';

function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = window.document.createElement('a');
  link.href = url;
  link.download = filename;
  window.document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/** Client-side ZIP of scan documents (DOC-013B — no SMTP / no new Backend API). */
export async function downloadScanDocumentsArchive(
  entries: ScanArchiveDocumentEntry[],
  archiveFilename: string
): Promise<void> {
  if (entries.length === 0) {
    throw new Error('SCAN_ARCHIVE_EMPTY');
  }

  const zip = new JSZip();

  for (const entry of entries) {
    const { blob, filename } = await fetchDocumentBlob(entry.documentId);
    const zipName = entry.zipEntryName || filename;
    zip.file(zipName, blob);
  }

  const archiveBlob = await zip.generateAsync({ type: 'blob' });
  triggerBrowserDownload(archiveBlob, archiveFilename);
}
